import React from "react";
import "./checkoutPageSkeleton.css";

const CheckoutSkeleton = () => {
    return (
        <div className="sf-checkout-skeleton">
            {/* Title */}
            <div className="sf-skel-title shimmer"></div>

            {/* Fake Paddle container */}
            <div className="sf-skel-box shimmer"></div>

            {/* Optional button row */}
            <div className="sf-skel-actions">
                <div className="sf-skel-btn shimmer"></div>
                <div className="sf-skel-btn shimmer"></div>
            </div>
        </div>
    );
};

export default CheckoutSkeleton;